import {isNil, isNotNil} from 'ramda';
import {isNonEmptyString} from 'ramda-adjunct';

import {useGetMakeModelWithMakeQuery} from '@dms/api/sales';
import i18n, {FALLBACK_LANGUAGE} from '@dms/i18n';

import {Nullish} from 'shared/web';

import {getVehicleTitle} from '../utils/getVehicleTitle';
import {useCustomTenantCatalogue} from './useCustomTenantCatalogue';

type Vehicle = {
  make?: string | null;
  customMake?: string | null;
  customModel?: string | null;
  vehicleType?: string;
  modelFamily?: string | null;
  trim?: string | null;
  variant?: string | null;
  title?: string | null;
};

export function useGetVehicleTitle(
  vehicle: Vehicle | Nullish
): [string | Nullish, {isLoading: boolean; isError: boolean}] {
  const {data, isLoading, isError} = useGetMakeModelWithMakeQuery(
    {
      vehicleType: vehicle?.vehicleType ?? '',
      make: vehicle?.make ?? '',
      lang: [i18n?.resolvedLanguage ?? FALLBACK_LANGUAGE],
    },
    {skip: isNonEmptyString(vehicle?.title) || isNil(vehicle?.vehicleType)}
  );

  const make = vehicle?.make;

  const {
    customMakeOptions,
    customModelOptions,
    isLoading: isCustomTenantCatalogueLoading,
    isError: isCustomTenantCatalogueErrored,
  } = useCustomTenantCatalogue(
    isNonEmptyString(vehicle?.title) ? null : vehicle?.vehicleType,
    isNotNil(make) && isNonEmptyString(make) ? [make] : null
  );

  return [
    isNotNil(vehicle)
      ? getVehicleTitle(vehicle, data, {
          makeOptions: customMakeOptions,
          modelOptions: customModelOptions,
        })
      : null,
    {
      isLoading: isLoading || isCustomTenantCatalogueLoading,
      isError: isError || isCustomTenantCatalogueErrored,
    },
  ];
}
